<template>
  <header v-if="!isWeChat">
    <div class="header-contain">
      <div class="header-middle">
        <router-link
          class="fl logo"
          :to="{ path: '/' }"
          @click.native="routerClickFn"
          push
        >
          <!-- <img class="logo" src="data:image/gif;base64,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"> -->
          <span v-if="language === 'ch'"></span>
          <img
            v-else
            src="~assets/main-page/nav_btn_logo@3x.png"
            class="logo"
          />
        </router-link>
        <a
          class="show-avatar-img tap-box"
          href="https://cc.oceanbluecloud.com/"
        >
          <img src="~assets/main-page/nav_btn_login.png" />
        </a>
        <a class="show-menu-img tap-box" v-tap="{ methods: showFirstMenu }">
          <img
            src="data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAwCAYAAABNPhkJAAAABGdBTUEAALGPC/xhBQAAATVJREFUaAXtmjESAUEQRQ2pROgIIjGBQCBxApbQERxCuQE5FyARCmxKrSrRphyAdK3/g6mSCWTdv6t+zeyK3htL9exUKqiyLBMkQwrEWpGJbAlZAyYjjBteOKgxgc8AbTuAJeKFwE9M6k6AX1WAZk5giZlxhfuYHJAa7xiuAmyDQEBAdzHMkRZiDZygN2QZQjhhVMmADMiADMiADMiADMiADMjAbwOxW2KH1EMsd0tHdEsF++EGQPdIB7FcKeCGBF5hMrNM+sW2JvAdN5pfNy1PH9zTclUE3jki3vn70eLq4jl287fk6NssVBmQARmQARmQARmQARmQgX8MxE08N0ce2A/7OtQCYB70sL5jGZ+ClCvs7mBaHvEdjDk38RYOQCPioorXD1tcTZAr8o6fGBrJRLYpWT+7UEMEgMF5qQAAAABJRU5ErkJggg=="
          />
        </a>
        <a v-tap="{ methods: hideFirstMenu }" class="hide-menu-img tap-box">
          <img src="~assets/main-page/nav_btn_tab_close@3x.png" />
        </a>
      </div>
      <!--menu-->
      <div class="menu-contain">
        <ul class="first-menu">
          <!-- 解决方案 -->
          <li class="first-item item clear">
            <div v-tap="{ methods: toggleSecondMenu }" class="text-contain">
              <span class="fl">{{ $t("language.headerSolutions") }}</span>
              <img
                src="~assets/main-page/Chevron Copy@3x.png"
                class="fr trangle-img"
              />
            </div>

            <ul class="second-menu">
              <!-- 企业 -->
              <li class="text-contain">
                <router-link
                  :to="{ path: '/solutions/enterprise' }"
                  @click.native="routerClickFn"
                  push
                  >{{ $t("m.enterprise") }}</router-link
                >
              </li>
              <!-- 多点组网 -->
              <li class="text-contain">
                <router-link
                  :to="{ path: '/solutions/virtualNetwork' }"
                  @click.native="routerClickFn"
                  push
                  >{{ $t("m.vn") }}</router-link
                >
              </li>

              <!-- <li class="text-contain">
                <router-link
                  :to="{ path: '/solutions' }"
                  @click.native="routerClickFn"
                  push
                  >{{ $t("language.headerSolutionsOur") }}</router-link
                >
              </li> -->
              <!-- <li class="text-contain">
                <router-link
                  :to="{ path: '/solutions/saas' }"
                  @click.native="routerClickFn"
                  push
                  >{{ $t("language.headerSolutionsSaas") }}</router-link
                >
              </li> -->
              <!-- <li class="text-contain">
                <router-link
                  :to="{ path: '/solutions/cloud' }"
                  @click.native="routerClickFn"
                  push
                  >{{ $t("language.headerSolutionsCloud") }}</router-link
                >
              </li> -->
              <!-- <li class="text-contain">
                <router-link
                  :to="{ path: '/solutions/mpls' }"
                  @click.native="routerClickFn"
                  push
                  >{{ $t("language.headerSolutionsMpls") }}</router-link
                >
              </li> -->
              <!-- <li class="text-contain">
                <router-link
                  :to="{ path: '/solutions/global' }"
                  @click.native="routerClickFn"
                  push
                  >{{ $t("language.headerSolutionGlobal") }}</router-link
                >
              </li> -->
              <li class="space"></li>
            </ul>
          </li>
          <!-- 产品 -->
          <li class="first-item item clear">
            <div v-tap="{ methods: toggleSecondMenu }" class="text-contain">
              <span class="fl">{{ $t("m.product") }}</span>
              <img
                src="~assets/main-page/Chevron Copy@3x.png"
                class="fr trangle-img"
              />
            </div>

            <ul class="second-menu">
              <!-- 云快线 -->
              <li class="text-contain">
                <router-link
                  class="fl"
                  :to="{ path: '/product/connection' }"
                  @click.native="routerClickFn"
                  push
                  >{{ $t("language.headerServicesConnection") }}</router-link
                >
              </li>
              <!-- 云快递 -->
              <li class="text-contain">
                <router-link
                  class="fl"
                  :to="{ path: '/product/delivery' }"
                  @click.native="routerClickFn"
                  push
                  >{{ $t("language.headerServicesDelivery") }}</router-link
                >
              </li>
              <!-- 全球应用访问 -->
              <li class="text-contain">
                <router-link
                  class="fl"
                  :to="{ path: '/product/global' }"
                  @click.native="routerClickFn"
                  push
                  >{{ $t("language.headerServicesGlobal") }}</router-link
                >
              </li>
              <!-- 移动应用 -->
              <li class="text-contain">
                <router-link
                  class="fl"
                  :to="{ path: '/product/mobility' }"
                  @click.native="routerClickFn"
                  push
                  >{{ $t("m.mobility") }}</router-link
                >
              </li>
              <!-- 设备 -->
              <li class="text-contain">
                <router-link
                  class="fl"
                  :to="{ path: '/services/device/R100-X6' }"
                  @click.native="routerClickFn"
                  push
                  >{{ $t("language.device") }}</router-link
                >
              </li>

              <li class="space"></li>
            </ul>
          </li>
          <!-- 技术 -->
          <li class="first-item item clear">
            <div v-tap="{ methods: toggleSecondMenu }" class="text-contain">
              <span class="fl">{{ $t("m.technology") }}</span>
              <img
                src="~assets/main-page/Chevron Copy@3x.png"
                class="fr trangle-img"
              />
            </div>
            <ul class="second-menu second-newMenu">
              <!-- SD-WAN -->
              <li class="text-contain">
                <router-link
                  class="fl"
                  :to="{ path: '/services/sdwan' }"
                  @click.native="routerClickFn"
                  push
                  >{{ $t("language.headerServicesSd") }}</router-link
                >
              </li>
              <!-- 下载 -->
              <li class="text-contain">
                <router-link
                  class="fl"
                  :to="{ path: '/technology/download' }"
                  @click.native="routerClickFn"
                  push
                  >{{ $t("m.download") }}</router-link
                >
              </li>
              <!-- <li class="text-contain">
                <router-link
                  class="fl"
                  :to="{ path: '/services' }"
                  @click.native="routerClickFn"
                  push
                  >{{ $t("language.headerServicesOur") }}</router-link
                >
              </li> -->
              <!-- 客户端下载 -->
              <li class="text-contain">
                <router-link
                  class="fl"
                  :to="{ path: '/services/download' }"
                  @click.native="routerClickFn"
                  push
                  >{{ $t("language.downloadHeader") }}</router-link
                >
              </li>
              <!-- 免费试用 -->
              <li class="text-contain">
                <router-link
                  class="fl"
                  :to="{ path: '/free-trial' }"
                  @click.native="routerClickFn"
                  push
                  >{{ $t("language.freeTitle") }}</router-link
                >
              </li>
              <!-- 合作申请 -->
              <li class="text-contain">
                <router-link
                  class="fl"
                  :to="{ path: '/partner-apply' }"
                  @click.native="routerClickFn"
                  push
                  >{{ $t("language.partner_title") }}</router-link
                >
              </li>
              <li class="space"></li>
            </ul>
          </li>
          <!-- <li class="first-item item clear" >
          <div class="about text-contain">
            <router-link :to="{ path: '/solutions/saas'}" @click.native="routerClickFn" push>{{ $t("language.headerSolutions") }}</router-link>
          </div>
        </li> -->
          <!-- <li class="first-item item clear">
          <div class="about text-contain">
            <router-link :to="{ path: '/about'}" @click.native="routerClickFn" push>{{ $t("language.headerAbout") }}</router-link>
          </div>
        </li> -->
          <!-- 关于我们 -->
          <li class="first-item item clear">
            <div v-tap="{ methods: toggleSecondMenu }" class="text-contain">
              <span class="fl">{{ $t("language.headerAbout") }}</span>
              <img
                src="~assets/main-page/Chevron Copy@3x.png"
                class="fr trangle-img"
              />
            </div>
            <ul class="second-menu company-menu">
              <!-- 关于我们 -->
              <li class="text-contain">
                <router-link
                  :to="{ path: '/about' }"
                  @click.native="routerClickFn"
                  push
                  >{{ $t("m.aboutUs") }}</router-link
                >
              </li>
              <!-- <li class="text-contain">
                <router-link
                  :to="{ path: '/investor' }"
                  @click.native="routerClickFn"
                  push
                  >{{ $t("language.aboutInver") }}</router-link
                >
              </li> -->
              <!-- 专家团队 -->
              <li class="text-contain">
                <router-link
                  :to="{ path: '/expert' }"
                  @click.native="routerClickFn"
                  push
                  >{{ $t("language.manage") }}</router-link
                >
              </li>
              <!-- 证书 -->
              <li class="text-contain">
                <router-link
                  :to="{ path: '/award' }"
                  @click.native="routerClickFn"
                  push
                  >{{ $t("m.awards") }}</router-link
                >
              </li>
              <!-- 新闻 -->
              <li class="text-contain">
                <router-link
                  :to="{ path: '/news' }"
                  @click.native="routerClickFn"
                  push
                  >{{ $t("m.news") }}</router-link
                >
              </li>
              <!-- <li class="text-contain">
                <router-link
                  :to="{ path: '/join' }"
                  @click.native="routerClickFn"
                  push
                  >{{ $t("language.joinTitle") }}</router-link
                >
              </li> -->
            </ul>
          </li>

          <!-- <li class="first-item item clear">
            <div class="about text-contain">
              <router-link
                :to="{ path: '/free-trial' }"
                @click.native="routerClickFn"
                push
                >{{ $t("language.freeTitle") }}</router-link
              >
            </div>
          </li>

          <li class="first-item item clear">
            <div class="about text-contain">
              <router-link
                :to="{ path: '/partner-apply' }"
                @click.native="routerClickFn"
                push
                >{{ $t("language. partner_title") }}</router-link
              >
            </div>
          </li> -->

          <li class="first-item item clear">
            <!-- <div v-tap="{methods: changeLanguage}" class="chang-language text-contain"> -->
            <div class="chang-language text-contain">
              <img
                class="language-img"
                src="data:image/gif;base64,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"
              />
              <a v-on:click="changeLanguage()">{{
                $t("language.headerLanguage")
              }}</a>
              <!-- <a v-tap="{methods: changeLanguage}"><router-link :to="{ path: '/' }" @click.native="routerClickFn" push>{{ $t('language.headerLanguage') }}</router-link></a> -->
              <!-- <a>{{ $t("language.headerLanguage") }}</a> -->
            </div>
          </li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
import vueObject from "../bus.js";
export default {
  name: "Header",
  props: ["language"],
  data() {
    return {
      lang: "",
      isWeChat: false,
    };
  },
  methods: {
    routerClickFn: function () {
      $("body").css("overflow", "");
      this.hideFirstMenu();
    },
    showFirstMenu: function (e) {
      //高度与标签个数有耦合ssss
      $("header").addClass("header-show-menu");
      $(".menu-contain").outerHeight(
        window.innerHeight - $(".header-contain").outerHeight()
      );
    },
    hideFirstMenu: function (e) {
      $("header").removeClass("header-show-menu");
      $(".first-item").removeClass("show-second-menu");
      $(".menu-contain").outerHeight(0);
    },
    toggleSecondMenu: function (event) {
      $(event.event.target)
        .closest(".first-item")
        .toggleClass("show-second-menu");
    },
    changeLanguage: function () {
      localStorage.language === "en"
        ? localStorage.setItem("language", "ch")
        : localStorage.setItem("language", "en");
      this.$parent._i18n.locale = localStorage.language;
      this.$parent.language = this.$parent._i18n.locale;
      // this.$router.push({ path: "/" });
      vueObject.$emit("langChange", this.$parent._i18n.locale);
      this.hideFirstMenu();
      this.initUdesk();
    },
    initUdesk: function () {
      (function (a, h, c, b, f, g) {
        a["UdeskApiObject"] = f;
        a[f] =
          a[f] ||
          function () {
            (a[f].d = a[f].d || []).push(arguments);
          };
        g = h.createElement(c);
        g.async = 1;
        g.charset = "utf-8";
        g.src = b;
        c = h.getElementsByTagName(c)[0];
        c.parentNode.insertBefore(g, c);
      })(
        window,
        document,
        "script",
        "//assets-cli.udesk.cn/im_client/js/udeskApi.js",
        "ud"
      );
      ud({
        code: "25972ccj",
        link: "//oceanbluecloud.udesk.cn/im_client/?web_plugin_id=41861",
        language: this.$parent._i18n.locale == "en" ? "en-us" : "zh-cn",
        pos_flag: "crb",
      });
    },
  },
  mounted() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      this.isWeChat = true;
    } else {
      this.isWeChat = false;
      this.initUdesk();
    }
  },
};
</script>

<style scoped lang="scss">
$menuHeight: 50px;
$liHeight: 40px;
$spaceHeight: 32px;
@function toRem($x) {
  @return $x / 37.5 * 1rem;
}
header {
  height: $menuHeight;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #323232;
  z-index: 1000;
  -webkit-transition: background-color 0.5s;
  -moz-transition: background-color 0.5s;
  transition: background-color 0.5s;
}
header a {
  text-decoration: none;
}
.header-contain {
  height: $menuHeight;
  overflow: hidden;
  position: relative;
}
.header-contain .tap-box {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  padding-left: 30px;
  padding-right: 30px;
  z-index: 9999;
  line-height: 50px;
}
.header-middle {
  height: $menuHeight;
  padding-left: 36px;
  width: 100%;
}
.header-middle .logo {
  line-height: 46px;
}
.header-middle .logo img {
  width: 80px;
  height: 28px;
  vertical-align: middle;
}

.logo span {
  display: inline-block;
  width: 80px;
  height: 28px;
  background: url(../assets/ch-logo.png) no-repeat;
  background-size: 100%;
  margin-top: 18px;
}

.header-middle .item .tap-box {
  padding: 0 55px;
  height: $menuHeight;
  padding-top: 15px;
  width: 110px;
}

.header-middle img {
  vertical-align: middle;
}
.header-middle .icon {
  margin-top: 15px;
}
.header-middle .icon-man {
  width: 19px;
  height: 20px;
}
.header-middle .show-menu-img img {
  width: 20px;
  height: 16px;
}
.header-middle .hide-menu-img {
  display: none;
}
.header-middle .hide-menu-img img {
  width: 16px;
  height: 16px;
}
.header-middle .show-avatar-img img {
  margin-right: 41px;
  width: 19px;
  height: 20px;
}

/*下拉菜单*/
.menu-contain {
  padding: 0 36px;
  color: #fff;
  background: #323232;
  height: 0;
  position: fixed;
  z-index: 1000;
  top: 50px;
  width: 100%;
  overflow: hidden;
  -webkit-transition: All 0.5s;
  -moz-transition: All 0.5s;
  transition: All 0.5s;
}
.menu-contain .text-contain {
  height: $liHeight;
  border-bottom: 1px solid #333;
  line-height: 22px;
  font-size: 15px;
}
.menu-contain .language-img {
  width: 16px;
  height: 17px;
  vertical-align: top;
}
.menu-contain .chang-language a {
  touch-action: manipulation;
  vertical-align: top;
  width: 80%;
  display: inline-block;
  line-height: 17px;
  margin-left: 4px;
}
.menu-contain .first-item > .text-contain {
  padding-top: 14px;
}
.menu-contain .second-menu .text-contain a {
  padding-top: 14px;
  display: inline-block;
  height: 100%;
  width: 100%;
}
.about a {
  display: inline-block;
  height: 100%;
  width: 100%;
}
.menu-contain .item .trangle-img {
  display: inline-block;
  width: 14px;
  height: 6px;
  margin-top: 7px;
  -webkit-transition: -webkit-transform 0.5s;
  -moz-transition: -moz-transform 0.5s;
  transition: transform 0.5s;
}
/*二级菜单*/
.second-menu {
  height: 0;
  overflow: hidden;
  -webkit-transition: height 0.5s;
  -moz-transition: height 0.5s;
  transition: height 0.5s;
  padding-left: 20px;
  font-weight: 300;
}
.second-menu .space {
  height: $spaceHeight;
}

/*展示菜单*/
header.header-show-menu {
  background: #000 !important;
}
.header-show-menu .menu-contain {
  overflow: auto !important;
  background: #000 !important;
  padding-bottom: 36px;
}
.header-show-menu .show-menu-img {
  display: none !important;
}
.header-show-menu .hide-menu-img {
  display: block !important;
}
.first-item.show-second-menu .second-menu {
  height: 205px;
}
.first-item.show-second-menu .second-newMenu {
  height: 285px;
}
.language-ch .first-item.show-second-menu .company-menu {
  height: 180px;
}
.menu-contain .item.show-second-menu .trangle-img {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  transform: rotate(180deg);
}
</style>



// WEBPACK FOOTER //
// Header.vue?ca584380